export const EMPTY_USER_NAME = "Достопочтенный Господин";
